module.exports = __webpack_public_path__ + "img/pb-logo.31290f06.png";